if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll(".product-tabs__tab");
      this.panels = this.querySelectorAll(".product-tabs__panel");
      this.bindEvents();
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          this.switchTab(tab.dataset.tabIndex);
        });
      });
    }

    switchTab(index) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tabIndex === index;
        tab.classList.toggle("product-tabs__tab--active", isActive);
        tab.setAttribute("aria-selected", isActive);
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === index;
        panel.classList.toggle("product-tabs__panel--active", isActive);
        panel.hidden = !isActive;

        if (isActive) {
          const slider = panel.querySelector("css-slider");
          if (slider && typeof slider.resetSlider === "function") {
            slider.resetSlider();
          } else if (slider && typeof slider.init === "function") {
            slider.init();
          }
        }
      });
    }
  }

  customElements.define("product-tabs", ProductTabs);
}
